import React from 'react';
import PropTypes from 'prop-types';

export function SelectedFilterTag({ onRemove, children, name }) {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onRemove(event);
    }
  };

  return (
    <div className="tag_container">
      <div className="tag_container_label">{children}</div>
      <div
        className="tag_container_remove_tag"
        onClick={onRemove}
        onKeyDown={handleKeyDown}
        tabIndex="0"
        role="button"
        aria-label={`Selected ${name}, press Enter to remove ${name} from the selected values`}
      >
        <svg
          height="14"
          width="14"
          viewBox="0 0 20 20"
          aria-hidden="true"
          focusable="false"
          className="tag_container_remove_tag_icon"
        >
          <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
        </svg>
      </div>
    </div>
  );
}

SelectedFilterTag.propTypes = {
  onRemove: PropTypes.func.isRequired,
  name: PropTypes.string
};

SelectedFilterTag.defaultProps = {
  name: ''
};
